module.exports = __webpack_public_path__ + "img/3.f39b15a7.png";